import { ReactElement, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import * as actions from '@redux-actions/';

import { getItemDiscountedTotalPrice, getLabelFallback, convertBase64, handleHTTPError, getItemDiscountedTotalPriceWithWarranty, isThereAnAddedWarranty } from '@utils/utils';

import Image from '@components/Image';
import PrescriptionModal from '@components/PrescriptionModal';

import Vector from '@images/svg-icons/vector.svg';
import Prescription from '@images/svg-icons/prescription.svg';
import Upload from '@images/svg-icons/upload.svg';
import { sendPrescription } from '@utils/services';

type CartProductResumeProps = {
    item: any;
    sizes: any;
    prescriptionPosition: 'top' | 'bottom';
    showBadge?: boolean;
    onSubmitPrescription?: () => void;
    isTyp?: boolean;
}

const CartProductResume = (props : CartProductResumeProps) : ReactElement => {

    const {
        item,
        sizes,
        prescriptionPosition,
        showBadge = false,
        onSubmitPrescription,
        isTyp = false,
    } = props;

    const dispatch = useDispatch();
    const { register, handleSubmit, formState: { errors }, clearErrors } = useForm();

    const assetsUrl = useSelector(state => state.cart.config.assetsUrl);
    const isMobile = useSelector(state => state.cart.isMobile);
    const config = useSelector(state => state.cart.config);
    const prescriptionFromTyp = useSelector(state => state.cart.prescriptionFromTyp);
    const cart = useSelector(state => state.cart.cart);
    const selectedShippingMode = useSelector(state => state.cart.selectedShippingMode);


    const onSubmit = async (data) => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        const file = document.getElementById('prescription').files[0];
        if(!!file) {
            clearErrors();
            let base64 = await convertBase64(file) as string;
            if(base64.search('base64,') !== -1) {
                base64 = base64.split('base64,')[1];
            }
        
            const orderId = urlParams.get('orderId');
            const email = urlParams.get('email');
            
            const dataToSend = {
                "storeId": config.storeId,
                "orderId": orderId,
                "lensId": item.lenses.orderItemId,
                "emailAddress": email,
                "FILE_NAME": file.name,
                "RX": "doctor",
                "PRESCRIPTION_MODE": "uploadPrescription",
                "FILE": base64
            };

            dispatch(actions.startLoading());

            await sendPrescription(
                config.hostname,
                dataToSend
            ).then((res: any) => {
                if(res.status === 200) {
                   onSubmitPrescription && onSubmitPrescription();
                }
            }).catch(err => {
                console.error('>>> Send prescription => error status:', err.status, ', error: ', err);
                handleHTTPError(dispatch, actions, err);
                dispatch(actions.errorLoading());
            })
        } 
    }

    const [showPrescriptionModal, setShowPrescritionModal] = useState(false);
    const [showPrescriptionForm, setshowPrescriptionForm] = useState(false);
    const [uploadFileFeedback, setUploadFileFeedback] = useState(<></>);
    const [disabledButton, setDisabledButton] = useState(false);

    const sizesToUse = isMobile ? sizes.mobile : sizes.desktop;

    const getLensesProperties = () => {
        if(!!item.frame.xitem_rxcReviewObject) {
            return item.frame.xitem_rxcReviewObject.map((p, index) => {
                if(!p.children) {
                    if(p.name !== 'Prescription' &&
                    (p.description !== 'Glasses Protection Plan' && p.description !== 'steps.protectionplan.asIs' && p.description!=='i do not want it')) {
                        return <span key={'resume-lenses-properties-' + index}>{p.description}</span>
                    }
                } else {
                    return  (p.children.map((child, index2) => {
                                return (
                                    <span key={'resume-lenses-properties-' + index + '-child-'+index2}>
                                        {child.name}
                                    </span>
                                )
                            }))
                }            
            })
        } else {
            return <></>
        }
    }

    const getWarrantyProperties = () => {
        if(!!cart && isThereAnAddedWarranty(cart, item.frame.orderItemId)) {
            return <span>{"Glasses Protection Plan"}</span>
        }
        else{
            return <span>{"None"}</span>
        }
    }

    const validateSize = (e) => {
        clearErrors();
        if ((e.target.files[0].size / 1024 / 1024) > 10) {
            setUploadFileFeedback(<span className="file-error">{getLabelFallback('UPLOAD_FILE_ERROR_LABEL')}</span>);
            setDisabledButton(true);
        } else {
            setUploadFileFeedback(<span className="file-success">{getLabelFallback('UPLOAD_FILE_SUCCESS_LABEL')}</span>);
            setDisabledButton(false);
        }
    }

    return(
        <div className="cart-product-resume">
            {prescriptionPosition === 'top' && !!item.frame.xitem_frameType && item.frame.xitem_frameType !== 'FRAME ONLY' && item.frame.xitem_frameType !== 'NO PRESCRIPTION' &&
                <div className={`cart-product-resume-header ${item.frame.xitem_frameType  === 'RX' ? (item.frame.xitem_prescriptionComplete === "true" || !!item.lenses.xitem_field2 && item.lenses.xitem_field2.length > 0) ? 'mod' : '' : ''} ${showPrescriptionForm ? 'mod' : ''}`}>
                    
                    <div className="cart-product-resume-header-content">
                        {item.frame.xitem_frameType  === 'RX' ?
                            (item.frame.xitem_prescriptionComplete === "true" || !!item.lenses.xitem_field2 && item.lenses.xitem_field2.length > 0) ?
                                <>  <div className="cart-product-resume-header-content-top">
                                        <label>{getLabelFallback('TYP_PRODUCT_PRESCRIPTION_OK')}! <span>{getLabelFallback('TYP_PRESCRIPTION_CLAIM')}</span></label>
                                        {Object.keys(item.prescription).length > 0 && (!!item.prescription.rightSphere || !!item.prescription.leftSphere || !!item.prescription.rightCyl || !!item.prescription.leftCyl || !!item.prescription.rightAxis || !!item.prescription.leftAxis) &&
                                            <>
                                                <button className="primary-button" onClick={() =>{
                                                    setShowPrescritionModal(true);
                                                    document.getElementById('content_wrapper_box').setAttribute("style", "z-index: 9999;");
                                                }}>{getLabelFallback('TYP_SEE_DETAILS_LABEL')} </button>
                                                {showPrescriptionModal &&
                                                    <PrescriptionModal close={ () => {
                                                        setShowPrescritionModal(false);
                                                        document.getElementById('content_wrapper_box').removeAttribute("style");
                                                    }} prescription={item.prescription}/>
                                                }
                                            </>
                                        }
                                    </div>
                                    {item.isOpthyCode &&                                   
                                        <span dangerouslySetInnerHTML={{__html: getLabelFallback('TYP_OPTHY_LABEL')
                                            .replace('{LEAVE_REVIEW}', '<a href="https://apps.apple.com/us/app/opthy/id1624663408" class="primary-button" data-analytics_available_call="0">'+ getLabelFallback('TYP_OPTHY_REVIEW')+'</a>')}}>
                                        </span>
                                    }                                  
                                </> :
                                !showPrescriptionForm ?
                                    <>
                                        <div className="cart-product-resume-header-content-container">
                                            <label className="cart-product-resume-header-content-title">
                                                {getLabelFallback('TYP_PRESCRIPTION_REQUESTED_TITLE')}
                                            </label>
                                            <label className="cart-product-resume-header-content-claim">
                                                {getLabelFallback('TYP_PRESCRIPTION_REQUESTED_WARNING')}
                                            </label>
                                        </div>
                                        <button className="cart-product-resume-header-content-button" onClick={() => setshowPrescriptionForm(true)}>{getLabelFallback('TYP_SEND_PRESCRIPTION_BUTTON')}</button>
                                    </>
                                :
                                    <div className="cart-product-resume-header-content-form">
                                        <div className="cart-product-resume-header-content-form-left">
                                            <label className="cart-product-resume-header-content-form-left-title">{ getLabelFallback('TYP_PRESCRIPTION_TITLE') }</label>
                                            <label className="cart-product-resume-header-content-form-left-claim">{ getLabelFallback('TYP_PRESCRIPTION_FORM_CLAIM') }</label>
                                        </div>
                                        <div className="cart-product-resume-header-content-form-right">
                                            <form onSubmit={handleSubmit(onSubmit)}>
                                                <div>
                                                    <input {...register("prescription", {required: true})} onChange={(e) => {validateSize(e)}} type="file" id="prescription" name="prescription" accept="image/png, image/jpeg, pdf"/>
                                                    <button className="upload-button" onClick={(e) => { e.preventDefault(); document.getElementById('prescription').click()}}><Upload />  { getLabelFallback('TYP_UPLOAD_BUTTON_LABEL') }</button>
                                                    <button type="submit" className={`violet-button ${disabledButton ? 'disabled' : 'none'}`}>{ getLabelFallback('TYP_SEND_PRESCRIPTION_BUTTON') }</button>
                                                </div>
                                                {!!errors['prescription'] && <span>{getLabelFallback('EMPTY_FILE_ERROR_LABEL')}</span>}
                                                {uploadFileFeedback}
                                            </form>
                                        </div>
                                    </div>
                            :
                            <></>
                        }
                    </div>
                </div>
            }
            <div className="cart-product-resume-top">
                <div className="cart-product-resume-top-left">
                    {showBadge && 
                        <div className="cart-product-resume-top-left-badge">
                            {
                                item.frame.xitem_frameType  === 'RX' ?
                                    (item.frame.xitem_prescriptionComplete === "true" || !!item.lenses.xitem_field2 && item.lenses.xitem_field2.length > 0) ?
                                    <label className="ok">
                                        <span><Vector width="15" height="10" viewBox="0 0 16 16"/></span>{getLabelFallback('TYP_PRODUCT_PRESCRIPTION_OK')}
                                    </label>
                                    :
                                    <label className="ko">
                                        <span><Prescription width="16" height="16" viewBox="0 0 16 16"/></span>{getLabelFallback('TYP_PRESCRIPTION_MISSING_LABEL')}
                                    </label>
                                :
                                <></>
                            }
    
                        </div>
                    }
                    <div className="cart-product-resume-top-left-image">
                        <Image 
                            width={sizesToUse.width}
                            height={sizesToUse.height}
                            src={!!item.frame.xitem_rxcImagery && !!item.frame.xitem_rxcImagery.productImage ? item.frame.xitem_rxcImagery.productImage : item.frame.xitem_imgUrl}
                            alt='alt image'
                        />
                    </div>
                    <label className="cart-product-resume-top-left-text">
                        {getLabelFallback("CURRENCY_LABEL")}
                        {!!cart && isThereAnAddedWarranty(cart, item.frame.orderItemId) ?
                        getItemDiscountedTotalPriceWithWarranty(item, cart.orderItem?.find(warrantyItem => (warrantyItem.comments == "WARRANTY" && warrantyItem.xitem_field1 == item.frame.orderItemId))?.orderItemPrice) :
                        getItemDiscountedTotalPrice(item)}
                    </label>
                </div>
                <div className="cart-product-resume-top-right">
                    <div className="cart-product-resume-top-right-frame">
                        <label>{getLabelFallback("PRODUCT_RESUME_FRAME_LABEL")}:</label>
                        <span>{!!item.badgeChannel && item.badgeChannel !== ''? item.brand + ' ' + item.badgeChannel : item.brand}/{item.modelName}</span>
                    </div>
                    {item.frame.xitem_rxcReviewObject &&
                        <div className={`cart-product-resume-top-right-lenses ${showBadge ? 'mod' : ''}`}>
                            <label>{getLabelFallback("PRODUCT_RESUME_LENSES_LABEL")}:</label>
                            {getLensesProperties()}
                        </div>
                    }
                    {   config.warranty.enableWarranty.toLowerCase() === "true" && 
                        <div className={`cart-product-resume-top-right-lenses ${showBadge ? 'mod' : ''}`}>
                            <label>{getLabelFallback("PRODUCT_RESUME_WARRANTY_PLAN_LABEL")}:</label>
                            {getWarrantyProperties()}
                        </div>
                    }
                </div>
            </div>
            {
                !!selectedShippingMode && !!selectedShippingMode.shipModeDescription && selectedShippingMode.shipModeDescription.toLowerCase() === 'speedy rx' && !isTyp &&
                    <div className='cart-product-resume-top speedy-rx'>
                        <span>{getLabelFallback('SPEEDY_RX_DETAIL_TEXT')}</span>
                        <label>{!!selectedShippingMode && (selectedShippingMode.field2 === '0.00' ? getLabelFallback('CART_RESUME_FREE_LABEL') : (getLabelFallback('CURRENCY_LABEL') + selectedShippingMode.field2 ))}</label>
                    </div>
            }
            {
                prescriptionPosition === 'bottom' && !!item.frame.xitem_frameType && item.frame.xitem_frameType !== 'FRAME ONLY' && item.frame.xitem_frameType !== 'NO PRESCRIPTION' &&
                    <div className={`cart-product-resume-bottom ${item.frame.xitem_frameType  === 'RX' ? item.frame.xitem_prescriptionComplete === "true" ? 'mod' : '' : ''}`}>
                    {
                        item.frame.xitem_frameType  === 'RX' ?
                            item.frame.xitem_prescriptionComplete === "true" ?
                                <label className="cart-product-resume-bottom-header">
                                    <span><Vector width="15" height="10" viewBox="0 0 16 16"/></span> {getLabelFallback('PRODUCT_RESUME_PRESCRIPTION_OK')}
                                </label>
                            :
                                <>
                                    <label className="cart-product-resume-bottom-header">{ getLabelFallback('PRODUCT_RESUME_PRESCRIPTION_LABEL') }</label>
                                    <label className="cart-product-resume-bottom-claim">{ getLabelFallback('PRODUCT_RESUME_PRESCRIPTION_CLAIM') }</label>
                                </>
                        :
                        <></>
                    }
                </div>
            }
            
        </div>
    )
}

export default CartProductResume;
